import { render, staticRenderFns } from "./AboutHero.vue?vue&type=template&id=c4649842&scoped=true"
import script from "./AboutHero.vue?vue&type=script&lang=js"
export * from "./AboutHero.vue?vue&type=script&lang=js"
import style0 from "./AboutHero.vue?vue&type=style&index=0&id=c4649842&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4649842",
  null
  
)

export default component.exports